var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "registration" }, [
    _c(
      "div",
      { staticClass: "registration__info" },
      [
        _c("LogoDigmedia"),
        _vm._v(" "),
        _c("ul", { staticClass: "registration__info-text-box" }, [
          _c("li", [_vm._v("App Version: " + _vm._s(_vm.appVersion))]),
          _vm._v(" "),
          _c("li", [_vm._v("IP: " + _vm._s(_vm.deviceIp))]),
          _vm._v(" "),
          _c("li", [_vm._v("Env: " + _vm._s(_vm.getEnvironment))]),
          _vm._v(" "),
          _c("li", [_vm._v(_vm._s(_vm.getTimeString))]),
          _vm._v(" "),
          _c("li", [_vm._v("Device: " + _vm._s(_vm.$store.state.deviceId))]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Building: " +
                _vm._s(_vm.$store.state.buildingId) +
                " (" +
                _vm._s(_vm.registratedBuildingInfo.buildingId) +
                ")"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Group: " +
                _vm._s(_vm.$store.state.groupId) +
                " (" +
                _vm._s(_vm.registratedBuildingInfo.groupId) +
                ")"
            )
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "registration-settings" },
      [
        _vm.fingerprintChecking
          ? [_vm._m(0)]
          : !_vm.hasBuildingId
          ? [
              _c("RegistrationInput", {
                attrs: {
                  title: "Hash ID",
                  value: _vm.getHashLastDigits,
                  subline: _vm.getHashId
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "registration-settings__info" }, [
                _c("h2", { staticClass: "registration-settings__info-title" }, [
                  _vm._v("Info")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "registration-settings__info-text" }, [
                  _vm._v(
                    "\n          Go to the Admin tool and assign device to building by hash ID (url: " +
                      _vm._s(_vm.adminUrl) +
                      ")\n        "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "registration-settings__info-text" }, [
                  _vm._v("\n          Afterwards press ENTER/SUBMIT\n        ")
                ])
              ])
            ]
          : [
              _c("div", { staticClass: "registration-settings__info" }, [
                _c("h2", { staticClass: "registration-settings__info-title" }, [
                  _vm._v("Building")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "registration-settings__info-text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.getBuildingId) +
                      " – " +
                      _vm._s(_vm.getBuildingName) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("RegistrationInput", {
                attrs: {
                  title: "Room number / Location:",
                  placeholder: "Room No.",
                  disabled: false,
                  active: _vm.selectedIndex === 0
                },
                on: {
                  select: function() {
                    return _vm.handleSelectInput(0)
                  }
                },
                model: {
                  value: _vm.room,
                  callback: function($$v) {
                    _vm.room = $$v
                  },
                  expression: "room"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "registration-submit" },
                [
                  _c(
                    "RegistrationButton",
                    {
                      attrs: { isActive: _vm.selectedIndex === 1 },
                      on: { click: _vm.handleSubmit }
                    },
                    [_vm._v("\n          Create Device\n        ")]
                  )
                ],
                1
              )
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "registration-settings__info" }, [
      _c("p", { staticClass: "registration-settings__info-text" }, [
        _vm._v("Gerät wird erkannt...")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c648d246", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c648d246","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Registration.vue
// module id = null
// module chunks = 